import { render, staticRenderFns } from "./EditTransportador.vue?vue&type=template&id=044fc3d0"
import script from "./EditTransportador.vue?vue&type=script&lang=js"
export * from "./EditTransportador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports